module.exports = __webpack_public_path__ + "static/media/404.5072f248.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Views/PageNotFound/404.png
// module id = 785
// module chunks = 0